import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledPrice = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('price', 'font-size')}, clamp(12px, 1vw, 14px));
    font-style: normal;
    line-height: 120%; /* 16.8px */
    
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('price', 'font-family')}, inherit);
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('price', 'font-weight')}, 500);
`

interface IProps {
    children: React.ReactNode;
    className?: string;
}

const ProductPriceWrap: React.FC<IProps> = ({className = "", children}) => {
    const classnames = `${GLOBAL_STYLE_CONFIG.splitByPrefix('price-wrapper')} ${className}`

    return (
        <StyledPrice className={classnames}>
            {children}
        </StyledPrice>
    );
};

export default ProductPriceWrap;